(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "normalizr", "../setting", "../../user/schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("normalizr"), require("../setting"), require("../../user/schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.normalizr, global.setting, global.schema);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _normalizr, _setting, _schema) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.membershipsSchema = _exports.membershipSchema = void 0;

  /**
   * Schema for a single membership
   * @type {schema.Entity}
   */
  var membershipSchema = new _normalizr.schema.Entity(_setting.membershipEntityKey, {
    user: _schema.userSchema
  });

  /**
   * Schema for multiple memberships
   * @type {Array<schema.Entity>}
   */
  _exports.membershipSchema = membershipSchema;
  var membershipsSchema = [membershipSchema];
  _exports.membershipsSchema = membershipsSchema;
});